module.exports = __webpack_public_path__ + "media/components/assets/img/bg/circle-shape-tl-dashboard-1c8821a4f49e924ef8e9d5847da4cbb8.svg";